import axios from 'axios'

export const getIncomingCalls = (options) => {
  return axios.get('/click-to-call/incoming-calls', { params: { ...options } })
}

export const deleteIncomingCall = (callId) => {
  return axios.delete(`/click-to-call/${callId}`)
}

export const deleteAllIncomingCall = () => {
  return axios.delete(`/click-to-call/all-calls-by-user`)
}

export const setCallWithActivity = async (callId) => {
  return axios.patch(`/click-to-call/set-call-with-activity/${callId}`)
}

export const getContactsByPhoneNumber = (options, phoneNumber) => {
  return axios.get('/click-to-call/contacts-by-phone-number', { params: { ...options, phoneNumber } })
}

export const getMissingCalls = (params) => {
  return axios.get('/click-to-call/missing-calls', { params })
}

export const insertMissingCalls = (params, body = null) => {
  return axios.post('/click-to-call/insert-missing-calls', body ?? {}, { params })
}

export const reconcileDurations = (body) => {
  return axios.post('/click-to-call/reconcile-durations', body)
}
